// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 5px 20px 5px;
}
.settings-header h5 {
  border-bottom: 2px solid #ed143d;
  display: inline-block;
  margin: 0;
  padding-bottom: 3px;
  letter-spacing: 1px;
  font-weight: 600;
}
.settings-header ion-icon {
  font-size: 24px;
}

ion-list ion-icon {
  color: #ed143d;
  font-size: 22px !important;
  margin-right: 10px;
}
ion-list hr {
  margin: 40px 0;
  height: 1px;
  background-color: #bcbcbc;
}
ion-list .settings-section {
  background-color: #efefef;
  border-radius: 8px;
  margin: 10px 0;
  padding: 0 4px 0 8px;
}
ion-list ion-item {
  --background: #efefef;
  border-radius: 8px;
  --padding-start: 8px;
  --padding-bottom: 6px;
  --padding-top: 6px;
  font-size: 15px;
  font-weight: 600;
}
ion-list ion-item img {
  height: 32px;
  width: 32px;
  border-radius: 6px;
  margin: 0 10px;
}

ion-select {
  transform: translateY(-4px);
}
ion-select ion-icon {
  transform: translateY(2px);
}

ion-select::part(label) {
  color: #888;
  font-size: 17px;
}

ion-select::part(container) {
  font-size: 15px;
}

ion-select::part(icon) {
  color: #ed143d;
  transform: translateY(10px);
}

ion-popover.help-popover {
  --width: 80vw;
  left: 0;
}
ion-popover.help-popover ion-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
ion-popover.help-popover ion-list div ion-icon {
  margin-right: 5px;
  font-size: 8px !important;
  color: black;
  vertical-align: middle;
}
ion-popover.help-popover ion-list div ion-label {
  font-size: 12px;
}
ion-popover.help-popover ion-list div ion-label span {
  font-weight: 600;
  font-size: 14px;
}

ion-popover.help-popover::part(content) {
  padding: 5px 10px;
}

ion-toggle {
  font-weight: 600;
  display: block;
  margin: 0 auto;
  --track-background-checked: #ed143d;
  width: 100%;
}
ion-toggle .toggle-label {
  display: flex;
  align-items: center;
  font-weight: 400;
  flex: 1;
  min-width: 0;
}
ion-toggle .toggle-label ion-icon {
  flex-shrink: 0;
}

ion-toggle::part(track) {
  flex-shrink: 0;
}

@media (max-width: 430px) {
  ion-toggle {
    --handle-width: 22px;
    --handle-height: 22px;
  }
  ion-toggle::part(track) {
    width: 46px;
    height: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/settings/settings.page.scss"],"names":[],"mappings":"AA8BA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;AA7BJ;AA+BI;EACI,gCAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA7BR;AAgCI;EACI,eAAA;AA9BR;;AAoCI;EACI,cAAA;EACA,0BAAA;EACA,kBAAA;AAjCR;AAqCI;EACI,cAAA;EACA,WAAA;EACA,yBAAA;AAnCR;AAyCI;EACI,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AAvCR;AA0CI;EACI,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAxCR;AAyCQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAvCZ;;AA6CA;EAII,2BAAA;AA7CJ;AA0CI;EACI,0BAAA;AAxCR;;AA4CA;EACI,WAAA;EACA,eAAA;AAzCJ;;AA4CA;EACI,eAAA;AAzCJ;;AA4CA;EACI,cAAA;EACA,2BAAA;AAzCJ;;AA4CA;EACI,aAAA;EACA,OAAA;AAzCJ;AA2CI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAzCR;AA4CY;EACI,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;AA1ChB;AA6CY;EACI,eAAA;AA3ChB;AA6CgB;EACI,gBAAA;EACA,eAAA;AA3CpB;;AAkDA;EACI,iBAAA;AA/CJ;;AAkDA;EACI,gBAAA;EACA,cAAA;EACA,cAAA;EACA,mCAAA;EACA,WAAA;AA/CJ;AAiDI;EACQ,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,OAAA;EACA,YAAA;AA/CZ;AAiDY;EACI,cAAA;AA/ChB;;AAoDA;EACI,cAAA;AAjDJ;;AAmDA;EACI;IACI,oBAAA;IACA,qBAAA;EAhDN;EAkDE;IACI,WAAA;IACA,YAAA;EAhDN;AACF","sourcesContent":["// ion-select::part(icon) {\n//     display: none;\n// }\n// ion-list {\n//     padding-top: 10px;\n// }\n\n\n// ion-icon {\n//     font-size: 32px;\n//     margin-right: 10px;\n// }\n\n\n// .spinner-background {\n//     position: absolute;\n//     top: 0;\n//     left: 0;\n//     bottom: 0;\n//     right: 0;\n//     background: rgba(0, 0, 0, 0.15);\n//     z-index: 999;\n//     display: flex;\n//     align-items: center;\n//     justify-content: center;\n// }\n\n// ion-select::part(label) {\n//     max-width: 75% !important;\n//   }\n.settings-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 10px 5px 20px 5px;\n\n    h5 {\n        border-bottom: 2px solid #ed143d;\n        display: inline-block;\n        margin: 0;\n        padding-bottom: 3px;\n        letter-spacing: 1px;\n        font-weight: 600;\n    }\n\n    ion-icon {\n        font-size: 24px;\n    }\n}\n\nion-list {\n\n    ion-icon {\n        color: #ed143d;\n        font-size: 22px !important;\n        margin-right: 10px;\n\n    }\n\n    hr {\n        margin: 40px 0;\n        height: 1px;\n        background-color: #bcbcbc;\n\n    }\n\n    \n\n    .settings-section {\n        background-color: #efefef;\n        border-radius: 8px;\n        margin: 10px 0;\n        padding: 0 4px 0 8px;\n    }\n\n    ion-item {\n        --background: #efefef;\n        border-radius: 8px;\n        --padding-start: 8px;\n        --padding-bottom: 6px;\n        --padding-top: 6px;\n        font-size: 15px;\n        font-weight: 600;\n        img {\n            height: 32px;\n            width: 32px;\n            border-radius: 6px;\n            margin: 0 10px\n        }\n\n    }\n}\n\nion-select {\n    ion-icon {\n        transform: translateY(2px);\n    }\n    transform: translateY(-4px);\n}\nion-select::part(label) {\n    color: #888;\n    font-size: 17px;\n}\n\nion-select::part(container) {\n    font-size: 15px;\n}\n\nion-select::part(icon) {\n    color: #ed143d;\n    transform: translateY(10px);\n}\n\nion-popover.help-popover {\n    --width: 80vw;\n    left: 0;\n\n    ion-list {\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n\n        div {\n            ion-icon {\n                margin-right: 5px;\n                font-size: 8px !important;\n                color: black;\n                vertical-align: middle;\n            }\n\n            ion-label {\n                font-size: 12px;\n\n                span {\n                    font-weight: 600;\n                    font-size: 14px;\n                }\n            }\n        }\n    }\n}\n\nion-popover.help-popover::part(content) {\n    padding: 5px 10px;\n\n}\nion-toggle {\n    font-weight: 600;\n    display: block;\n    margin: 0 auto;\n    --track-background-checked: #ed143d;\n    width: 100%;\n\n    .toggle-label {\n            display: flex;\n            align-items: center;\n            font-weight: 400;\n            flex: 1;\n            min-width: 0;\n    \n            ion-icon {\n                flex-shrink: 0;\n            }\n        }\n}\n\nion-toggle::part(track) {\n    flex-shrink: 0;\n}\n@media (max-width: 430px) {\n    ion-toggle {\n        --handle-width: 22px;\n        --handle-height: 22px;\n    }\n    ion-toggle::part(track) {\n        width: 46px;\n        height: 28px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
